// Ortak — "Kişisel veri" yetkisi olmayan kullanıcıya maskeli değerlerin hemen altında gösterilen
// statik bildirim. Canlı bölge DEĞİL (sayfa yüklenirken zaten vardır); durumu renk değil metin
// taşır. `EyeOff` = "kısmen gizli" (`Lock` = "değiştirilemez" için ayrılmıştır).
import { EyeOff } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function PersonnelMaskNotice() {
  const { t } = useTranslation();
  return (
    <p className="flex items-start gap-1.5 text-xs text-muted">
      <EyeOff aria-hidden="true" className="mt-0.5 size-3.5 shrink-0" />
      <span>{t('personnelForm.masked.notice')}</span>
    </p>
  );
}
